module.exports = __webpack_public_path__ + "assets/img/crayon5.574ce6b4.png";